import { keyBy } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../index';

export const getProductionComponentInstanceByGuid = createSelector(
  (state: RootState) => state.productionModels.orderedProductionComponentInstancesByBundleGuid,

  (orderedProductionComponentInstancesByBundleGuid) =>
    keyBy(
      Object.values(orderedProductionComponentInstancesByBundleGuid).flatMap((instances) => instances),
      (instance) => instance.guid,
    ),
);
